(function () {
    function sanitizeInput(input) {
        const div = document.createElement("div");
        div.textContent = input;
        return div.innerHTML;
    }

    function getSanitizedFormData() {
        const fields = ["geProduct", "professionalDesignation", "hcpName", "hcpLastNameForm", "hcpEmail", "phoneExtension", "address", "state", "department", "city", "zip", "querySubmitted", "facilityAffiliation", "requestType", "message", "salesRepEmail"];
        const data = {};
        for (const id of fields) {
            const element = document.getElementById(id);
            data[id] = sanitizeInput(element?.value || "");
        }
        data.clientId = sanitizeInput("13");
        return data;
    }

    async function encryptFormData(data) {
        const encoder = new TextEncoder();
        const key = await crypto.subtle.generateKey(
            { name: "AES-GCM", length: 256 },
            true,
            ["encrypt", "decrypt"]
        );

        const iv = crypto.getRandomValues(new Uint8Array(12)); // 96-bit IV
        const encodedData = encoder.encode(JSON.stringify(data));
        const encrypted = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, encodedData);

        const exportedKey = await crypto.subtle.exportKey("raw", key);

        return {
            ciphertext: btoa(String.fromCharCode(...new Uint8Array(encrypted))),
            iv: btoa(String.fromCharCode(...iv)),
            key: btoa(String.fromCharCode(...new Uint8Array(exportedKey))),
        };
    }
    // Function to allow only numbers
    function numbersonly(input) {
        var filter = /[^0-9]/g;
        input.value = input.value.replace(filter, "");
    }

    // Initialize Signature Pad
    var canvas = document.querySelector("canvas");
    var signaturePad = new SignaturePad(canvas);

    // Clear Signature
    document.getElementById("clear-signature").addEventListener("click", function () {
        signaturePad.clear();
    });

    document.getElementById("submitBtn").addEventListener("click", async function (event) {
        event.preventDefault();

        document.getElementById("loader-overlay").style.display = "block";

        if (!validateForm()) {
            document.getElementById("loader-overlay").style.display = "none";
            return;
        }

        const signatureData = signaturePad.isEmpty() ? "data:image/png;base64,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" : signaturePad.toDataURL();
        console.log("signature:", signatureData);
        

        const sanitizedData = getSanitizedFormData();

        try {
            const { ciphertext, iv, key } = await encryptFormData(sanitizedData);
            const payload = { ciphertext, iv, key, signatureData };

            const response = await fetch(
                window.medicalInformationRequestApi.post,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                },
            );

            const responseBody = await response.text(); // always read body once
            const responseJson = response.json();

            console.log("Test response : ", responseBody);
            console.log("Json response : ", responseJson);

            document.getElementById("loader-overlay").style.display = "none";

            if (response.ok) {
                showToast(responseBody);
                setTimeout(() => location.reload(), 5000);
            } else {
                showToast("Error: " + responseBody); // show the validation message
            }
        } catch (error) {
            console.error("Network error:", error);
            document.getElementById("loader-overlay").style.display = "none";
            showErrorToast("Network error: Unable to submit form");
        }


    });


    // Validation function
    function validateForm() {
        removeErrorMessages();
        const mandatoryFields = [
            "geProduct",
            "requestType",
            "professionalDesignation",
            "hcpName",
            "hcpLastNameForm",
            "hcpEmail",
            "facilityAffiliation",
            "city",
            "zip",
            "querySubmitted",
            "message",
        ];
        let isValid = true;

        for (const fieldId of mandatoryFields) {
            const field = document.getElementById(fieldId);
            const errorSpan = document.getElementById(`${fieldId}-error`);

            if (!field.value.trim()) {
                displayErrorMessage(errorSpan, `${getFieldLabel(fieldId)} is a mandatory field and cannot be empty.`);
                isValid = false;
            }
        }

        // Add server-side validation reminder
        console.warn("Server-side validation is required for all fields!");

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const hcpEmail = document.getElementById("hcpEmail").value;
        const emailErrorSpan = document.getElementById("hcpEmail-error");
        if (!emailRegex.test(hcpEmail)) {
            displayErrorMessage(emailErrorSpan, "Invalid email format in HCP Email field.");
            isValid = false;
        }

        const querySubmittedValid = document.getElementById("querySubmitted").value;
        const salesEmailErrorSpan = document.getElementById("salesRepEmail-error");

        if (querySubmittedValid == "Yes") {
            const salesRepEmail = document.getElementById("salesRepEmail").value;
            if (!emailRegex.test(salesRepEmail)) {
                displayErrorMessage(salesEmailErrorSpan, "Invalid email format in Sales Representative Email field.");
                isValid = false;
            }
        }

        return isValid;
    }

    // Function to display error message
    function displayErrorMessage(element, message) {
        if (element) {
            element.textContent = message;
            element.style.display = "block";
        } else {
            console.error("Element is null or undefined");
        }
    }

    // Function to remove error messages
    function removeErrorMessages() {
        const errorSpans = document.querySelectorAll('.error-message');
        errorSpans.forEach(span => span.textContent = '');
    }

    // Function to get field label
    function getFieldLabel(fieldId) {
        const labelElement = document.querySelector(`label[for="${fieldId}"]`);
        return labelElement ? labelElement.textContent : fieldId;
    }

    // Event listener for query submitted
    document.getElementById("querySubmitted").addEventListener("click", function (event) {
        event.preventDefault();
        var submittedBySales = this.value;
        var srMailDiv = document.getElementById("srMailDiv");
        srMailDiv.style.display = (submittedBySales == "Yes") ? "block" : "none";
    });

    // JavaScript for handling NPI search and fetching data
    const searchByNPI = document.getElementById("searchByNPI");
    const popup1 = document.getElementById("popup1");
    const popup2 = document.getElementById("popup2");
    const runDocumentButton = document.getElementById("runDocumentButton");
    const cancelPopup1 = document.getElementById("cancelPopup1");
    const closePopup2 = document.getElementById("closePopup2");
    const proceedButton = document.getElementById("proceedButton");
    const npiInput = document.getElementById("npiInput");
    const npiLabel = document.getElementById("npiLabel");
    const hcpFirstName = document.getElementById("hcpFirstName");
    const hcpLastName = document.getElementById("hcpLastName");
    const hcpLastNameForm = document.getElementById("hcpLastNameForm");
    const hcpMiddleName = document.getElementById("hcpMiddleName");
    const hcpCity = document.getElementById("hcpCity");
    const hcpState = document.getElementById("hcpState");
    const hcpPostalCode = document.getElementById("hcpPostalCode");
    const hcpPhone = document.getElementById("hcpPhone");
    const hcpCountryCode = document.getElementById("hcpCountryCode");
    const hcpCountryName = document.getElementById("hcpCountryName");
    const hcpAddressPurpose = document.getElementById("hcpAddressPurpose");
    const hcpAddressType = document.getElementById("hcpAddressType");
    const hcpAddress1 = document.getElementById("hcpAddress1");
    const hcpFaxNumber = document.getElementById("hcpFaxNumber");

    // Function to show the toast message
    function showToast(message) {
        var toast = document.getElementById("toast");
        toast.textContent = message; // Set the message dynamically
        toast.className = "toast show"; // Add 'show' class to display the toast
        // Hide the toast after 3 seconds
        setTimeout(function () {
            toast.className = toast.className.replace("show", ""); // Remove 'show' class to hide the toast
        }, 5000); // Toast disappears after 3 seconds
    }

    // Open Popup 1 when "Search By NPI" button is clicked
    searchByNPI.addEventListener("click", function () {
        popup1.style.display = "block";
    });

    // Close Popup 1 when Cancel is clicked
    cancelPopup1.addEventListener("click", function () {
        popup1.style.display = "none";
    });

    // Run Document Button: Fetch data based on NPI Number and show Popup 2
    runDocumentButton.addEventListener("click", function () {
        const npiValue = npiInput.value.trim();
        if (!npiValue || !/^\d+$/.test(npiValue) || npiValue.length < 10) {
            showToast("Please enter a valid NPI number!");

            // Clear the input field after the toast disappears
            setTimeout(function () {
                npiInput.value = ""; // Clear the NPI input field
            }, 3000); // 3 seconds delay before clearing the input field
            return;
        }

        // Fetch NPI data from API
        fetchNPIData(npiValue);
    });

    // Fetch NPI data from your API
    async function fetchNPIData(npi) {
        try {
            const apiUrl = window.medicalInformationRequestApi.npi
                .replace('## NPI ##', npi);
            const response = await fetch(apiUrl);
            const data = await response.json();

            if (data) {
                // Populate the second popup with the fetched data
                npiLabel.value = npi || '';
                hcpFirstName.value = data.firstName || '';
                hcpLastName.value = data.lastName || '';
                hcpMiddleName.value = data.middleName || '';
                hcpCity.value = data.city || '';
                hcpState.value = data.state || '';
                hcpPostalCode.value = data.postalCode || '';
                hcpPhone.value = data.telephoneNumber || '';

                hcpCountryCode.value = data.countryCode || '';
                hcpCountryName.value = data.countryName || '';
                hcpAddressPurpose.value = data.addressPurpose || '';
                hcpAddressType.value = data.addressType || '';
                hcpAddress1.value = data.address1 || '';
                hcpFaxNumber.value = data.faxNumber || '';

                popup1.style.display = "none";
                popup2.style.display = "block";
            } else {
                showToast("No data found for this NPI!");
            }
        } catch (error) {
            showToast('Failed to retrieve NPI data. Please Enter Valid NPI !');
        }
    }

    // Close Popup 2
    closePopup2.addEventListener("click", function () {
        popup2.style.display = "none";
    });

    // Add event listener for Proceed button to map fields to the healthCareForm
    proceedButton.addEventListener("click", function () {
        const stateField = document.getElementById("state");
        if (stateField) stateField.value = hcpState.value;

        const cityField = document.getElementById("city");
        if (cityField) cityField.value = hcpCity.value;

        const zipField = document.getElementById("zip");
        if (zipField) zipField.value = hcpPostalCode.value;

        const phoneField = document.getElementById("phoneExtension");
        if (phoneField) phoneField.value = hcpPhone.value;

        const firstNameField = document.getElementById("hcpName");
        if (firstNameField) firstNameField.value = hcpFirstName.value;

        const lastNameField = document.getElementById("hcpLastNameForm");
        if (lastNameField) lastNameField.value = hcpLastName.value;

        const countryCodeField = document.getElementById("countryCode");
        if (countryCodeField) countryCodeField.value = hcpCountryCode.value;

        const address1Field = document.getElementById("address");
        if (address1Field) address1Field.value = hcpAddress1.value;

        console.log("Form fields updated successfully.");
        popup2.style.display = "none";
    });
})();

